"use client";
import React from "react";
import { Box, Typography, Container } from "@mui/material";
import { useTranslation } from "react-i18next";

const RecruitingActuallyDo = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  return (
    <Box
      sx={{
        width: "100%",
        py: { xs: 5, sm: 6, md: 5 },
        borderBottom: "1px solid rgba(0,0,0,0.08)",
        direction: isArabic ? "rtl" : "ltr",
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: { xs: "flex-start", md: "flex-start" },
            justifyContent: "flex-start",
            gap: { xs: 3, md: 3 },
          }}
        >
          {/* LEFT: heading */}
          <Box
            sx={{
              flex: { md: "0 0 48%" },
              maxWidth: { xs: "100%", md: "48%" },
              textAlign: isArabic ? "right" : "left",
            }}
          >
            <Typography
              variant="h2"
              component="h2"
              sx={{
                fontFamily: "var(--font-plusjakarta)",
                fontWeight: 800,
                fontSize: { xs: "1.5rem", sm: "1.8rem", md: "2.2rem" },
                lineHeight: 1.3,
                color: "#1a1a2e",
                maxWidth: "100%",
              }}
            >
              {t("recruitingActuallyDoSection.heading1")}{" "}
              <Box component="span" sx={{ color: "#7C3AED" }}>
                {t("recruitingActuallyDoSection.heading2")}
              </Box>
            </Typography>
          </Box>

          {/* DIVIDER */}
          <Box
            sx={{
              display: { xs: "none", md: "block" },
              width: "2px",
              alignSelf: "stretch",
              backgroundColor: "#EADCFB",
              flexShrink: 0,
            }}
          />

          {/* RIGHT: description */}
          <Box
            sx={{
              flex: { md: "1 1 auto" },
              maxWidth: { xs: "100%", md: "48%" },
              textAlign: isArabic ? "right" : "left",
            }}
          >
            <Typography
              sx={{
                fontFamily: "var(--font-outfit)",
                fontSize: { xs: "0.85rem", sm: "0.9rem", md: "0.95rem" },
                color: "#55556E",
                lineHeight: 1.9,
              }}
            >
              {t("recruitingActuallyDoSection.description")}
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default RecruitingActuallyDo;